import React from "react";
import Helmet from "react-helmet";
import Head from "../../components/Partials/Head";
import { getCurrentLanguage } from '../../assets/js/functions';

const DafultLayout = ({ pageMeta, children }) => {
  return (
    <>
      <Helmet>
        <html className="h-100" lang={getCurrentLanguage()} />
        {pageMeta.desc ? (
          <meta name="description" content={pageMeta.desc} />
        ) : (
          ""
        )}
        {/* <title>{(pageMeta.title)?' | '+pageMeta.title:''}{translate('Preservem la memòria')} | {translate('Col·legi Oficial Infermeres i Infermers Barcelona')}</title> */}
        <Head></Head>
        <body id="top" className="is-size-4 h-100" />
      </Helmet>

      {children}
    </>
  );
};

export default DafultLayout;
